export function authHeaders() {
  const token = localStorage.getItem('paper_work_token');
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}
